// extracted by mini-css-extract-plugin
export default {"job-history":"JobHistory_job-history__PuqJb","remarks":"JobHistory_remarks__5ajre"};